import { useDispatch, useSelector } from 'react-redux';
import { Role } from '@/models/AccountEnums';
import { selectHideTransfers, setHideTransfers } from '@/store/filterSlice';
import { WARootState } from '@/store/store';

export function useHideTransfersChoice(
  userId: number | undefined,
  roleType: Role | undefined,
  firmHidesTransfers: boolean,
): [boolean, (hideTransfers: boolean) => void] {
  const dispatch = useDispatch();
  const savedHideTransfers = useSelector((state: WARootState) =>
    selectHideTransfers(state, userId, roleType),
  );

  const chooseHideTransfers = (hideTransfers: boolean) => {
    if (!userId || !roleType) return;
    dispatch(setHideTransfers({ userId, roleType, hideTransfers }));
  };

  return [savedHideTransfers ?? firmHidesTransfers, chooseHideTransfers];
}
